<script>
import SmartLink from "./SmartLink.svelte";
import {pages} from "../share/stores";

export let extraClass;
export let url;
export let text;

$:pathNow = $pages && $pages[$pages.length - 1].path;
</script>
<li class={extraClass} class:active={pathNow === url}>
	<SmartLink {text} {url}/>
</li>
